export default {
  container: {
    borderWidth: 0,
    display: 'flex',
    alignItems: 'flex-start',
    outline: 0,
    cursor: 'pointer'
  }
};
